import { TFunction } from "react-i18next";
import { OptionItem } from "../../types";
export interface Customer {
  id: string;
  name: string;
  customerDomainName: string;
  velocityEhsCustomerNumber: string;
  ssoEnabled: boolean;
  active: boolean;
  ssoIdentityProviderURL: string;
  customerOu: string;
  numberOfUsers?: string;
  locationManagementEnabled: boolean;
  orgHierarchyManagementEnabled: boolean;
  fullyIntegrated: boolean;
  adminDisplayName?: string;
  adminFirstName?: string;
  adminLastName?: string;
  adminEmail?: string;
  adminPhone?: string;
  adminUsername?: string;
  adminPassword?: string;
}

export type CustomerRequest = {
  id: string;
  name: string;
  customerDomainName: string;
  velocityEhsCustomerNumber: string;
  ssoEnabled: boolean;
  active: boolean;
  ssoIdentityProviderURL: string;
  customerOu: string;
  locationManagementEnabled?: boolean;
  orgHierarchyManagementEnabled?: boolean;
  fullyIntegrated?: boolean;

  admin?: {
    displayName: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    username: string;
    password: string;
  };
};

export const defaultCustomer: Customer = {
  id: "",
  name: "",
  customerDomainName: "",
  velocityEhsCustomerNumber: "",
  ssoEnabled: true,
  active: true,
  ssoIdentityProviderURL: "",
  customerOu: "",
  numberOfUsers: "",
  locationManagementEnabled: false,
  orgHierarchyManagementEnabled: false,
  fullyIntegrated: false,
  adminFirstName: "",
  adminLastName: "",
  adminEmail: "",
  adminPhone: "",
  adminUsername: "",
  adminPassword: "",
};

export enum CustomerStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export const CustomerStatusOptions = Object.values(CustomerStatus).map(
  (value) => ({
    id: value,
    label: value,
  })
);

export const getCustomerStatusOptions = (
  t: TFunction<"translation", undefined>
): OptionItem<boolean>[] => {
  return [
    { id: CustomerStatus.Active, value: true, label: t("status_active") },
    {
      id: CustomerStatus.Inactive,
      value: false,
      label: t("status_inactive"),
    },
  ];
};

export enum FullyIntegrated {
  Yes = "Yes",
  No = "No",
}

export const FullyIntegratedOptions = Object.values(FullyIntegrated).map(
  (value) => {
    return {
      id: value,
      label: value,
    };
  }
);
